import {Component, inject, OnInit, signal, ViewChild} from "@angular/core";
import {NgForm} from "@angular/forms";
import {CatalogueAchatDTO} from "../../../../../core/dtos/catalogue-achat-dto";
import {Subscription} from "rxjs";
import {CataloguesAchatsService} from "../../../../../core/services/entities/catalogues-achats.service";
import {ToastService} from "../../../../../core/services/technique/toast.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../../../core/constants";
import {UtilsService} from "../../../../../core/utils/utils.service";
import {UnitesDeMesuresService} from "../../../../../core/services/entities/unites-de-mesures.service";
import {UniteDeMesureDTO} from "../../../../../core/dtos/unitedemesure-dto";
import {LookUpComponent} from "../../../../../shared/ui/lookup/lookup.component";
import {CatalogueAchatPrixPeriodeDTO} from "../../../../../core/dtos/catalogue-achat-prix-periode-dto";
import {ButtonThemeEnum} from '../../../../../shared/ui/button/button-theme-enum';
import {CommandesService} from "../../../../../core/services/gestion-commandes/commandes.service";
import {BonCfDTO} from "../../../../../core/dtos/boncfs-dto";
import {InternationalizationService} from "../../../../../core/services/i8n/i8n.service";

@Component({
    selector: 'yo-dialog-save-period-price',
    templateUrl: './dialog-save-period-price.component.html',
    styleUrls: ['./dialog-save-period-price.component.scss'],
    standalone: false
})
export class DialogSavePeriodPriceComponent implements OnInit {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  private readonly i8nSvc = inject(InternationalizationService);

  bonCfImpacteList = signal<BonCfDTO[]>([]);
  displayBonCfImpacteDialog = signal(false);
  private isBonCfImpacteConfirmed: boolean = false;


  @ViewChild('articleForm') articleForm: NgForm;
  @ViewChild('uniteDeFacturation') uniteDeFacturation: LookUpComponent;
  @ViewChild('uniteDeCommande') uniteDeCommande: LookUpComponent;
  @ViewChild('uniteStockage') uniteStockage: LookUpComponent;

  displayDialog: boolean = false;
  isSaving: boolean = false;
  catalogueAchat: CatalogueAchatDTO;
  caPP: CatalogueAchatPrixPeriodeDTO;
  unitesMesure: UniteDeMesureDTO[] = [];

  subOpenDialog: Subscription;
  subSavePeriodPrice: Subscription;

  title: string;

  ratioUCUF: number;
  ratioUSUT: number;

  isSameUCUF: boolean;
  isSameUSUT: boolean;

  constructor(private utilsSvc: UtilsService,
              public catalogueAchatSvc: CataloguesAchatsService,
              private toastSvc: ToastService,
              private udmSvc: UnitesDeMesuresService,
              private commandesSvc: CommandesService) {
  }

  ngOnInit(): void {
    this.openDialogSaveSubscription();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenDialog);
    this.utilsSvc.unsubscribe(this.subSavePeriodPrice);
    if (this.isSaving) this.setSaving(false);
  }

  closeDialog = () => {
    this.caPP = null;
    this.catalogueAchat = null;
    this.ratioUCUF = null;
    this.ratioUSUT = null;
    this.isSameUCUF = null;
    this.isSameUSUT = null;
    this.displayDialog = false;
  }

  initData = () => {
    this.unitesMesure = this.udmSvc.unitesDeMesureEnvironnement;

    if (this.caPP.id) {
      this.title = 'MODIFIER PERIODE DE PRIX';
    } else {
      this.title = 'AJOUT PERIODE DE PRIX';
    }

    this.ratioUCUF = this.caPP.ratioUniteCommandeUniteBase / this.caPP.ratioUniteFacturationUniteBase;
    this.ratioUSUT = this.caPP.ratioUniteStockageUniteBase / this.catalogueAchat.ratioUniteTechnique;

    this.isSameUCUF = this.caPP.uniteDeCommande.id === this.caPP.uniteDeFacturation.id;
    if (this.isSameUCUF) this.ratioUCUF = 1;

    this.isSameUSUT = this.catalogueAchat.uniteTechnique.id === this.caPP.uniteDeStockage.id;
    if (this.isSameUSUT) this.ratioUSUT = 1;
  }

  openDialogSaveSubscription = () => {
    this.subOpenDialog = this.catalogueAchatSvc.openDialogSavePricePeriod$
      .subscribe((item) => {
        this.catalogueAchat = item.catalogueAchat;
        if (item.isUpdate) {
          this.caPP = item.caPP;
          if(!this.utilsSvc.isCollectionNullOrEmpty(this.caPP.groupeAchatCaList))
            this.caPP.prix = this.caPP.groupeAchatCaList[0].prixUF.value;
        } else {
          this.initCaPP();
        }
        this.displayDialog = true;

        this.initData();
      });
  }

  initCaPP = () => {
    this.caPP = new CatalogueAchatPrixPeriodeDTO();
    this.caPP.dateEffective = new Date();
    this.caPP.prix = this.catalogueAchat.prix;
    this.caPP.libelle = this.catalogueAchat.produitArticle?.libelle;
    this.caPP.referenceArticle = this.catalogueAchat.produitArticle?.reference;
    this.caPP.actif = this.catalogueAchat.actif;
    this.caPP.minimumCommande = this.catalogueAchat.minimumDeCommande;
    this.caPP.conditionnePar = this.catalogueAchat.conditionnePar;
    this.caPP.uniteDeCommande = this.catalogueAchat.uniteDeCommande;
    this.caPP.uniteDeFacturation = this.catalogueAchat.uniteDeFacturation;
    this.caPP.uniteDeStockage = this.catalogueAchat.uniteDeStockage;
    this.caPP.ratioUniteCommandeUniteBase = this.catalogueAchat.ratioUniteCommandeUniteBase;
    this.caPP.ratioUniteFacturationUniteBase = this.catalogueAchat.ratioUniteFacturationUniteBase;
    this.caPP.ratioUniteStockageUniteBase = this.catalogueAchat.ratioUniteStockageUniteBase;
    this.caPP.catalogueAchat = this.catalogueAchat;
    this.caPP.groupeAchatCaList = this.catalogueAchat.groupeAchatCaList;
  }

  save = () => {
    if (this.isSaving) return;
    this.setSaving(true);

    // HttpService filtre les réponses en erreur : le flux peut se terminer sans valeur
    let hasResponse = false;
    this.commandesSvc.findBonCfEnCoursByCatalogueAchat(this.caPP.catalogueAchat.id, this.caPP.dateEffective).subscribe({
      next: response => {
        hasResponse = true;
        const bonCfEnCoursList = response.resultList ?? [];

        if (!bonCfEnCoursList.length) {
          this.doSave([]);
          return;
        }

        // Le blocage est levé le temps de la confirmation, sinon il recouvre la boîte de dialogue
        this.utilsSvc.announceSubjectBlockui(false);
        this.bonCfImpacteList.set(bonCfEnCoursList);
        this.isBonCfImpacteConfirmed = false;
        this.displayBonCfImpacteDialog.set(true);
      },
      error: () => this.setSaving(false),
      complete: () => {
        if (!hasResponse) this.setSaving(false);
      }
    });
  }

  confirmBonCfImpacte = () => {
    this.isBonCfImpacteConfirmed = true;
    this.displayBonCfImpacteDialog.set(false);
  }

  cancelBonCfImpacte = () => this.displayBonCfImpacteDialog.set(false);

  // Le save part à la fermeture effective de la popup : la croix et Échap passent aussi par ici et valent Annuler
  onBonCfImpacteHidden = () => {
    if (this.isBonCfImpacteConfirmed) this.doSave(this.bonCfImpacteList().map(bonCf => bonCf.id));
    else this.setSaving(false);
  }

  label = (code: string): string => this.i8nSvc.getLabelFromCode(code);

  fournisseurOf = (bonCf: BonCfDTO): string =>
    [bonCf.fournisseurLibelle, bonCf.fournisseurCode ? `(${bonCf.fournisseurCode})` : null].filter(Boolean).join(' ');

  dateLivraisonOf = (bonCf: BonCfDTO): string =>
    bonCf.dateLivraisonAjustee ? new Date(bonCf.dateLivraisonAjustee).toLocaleDateString('fr-FR') : '';

  copyBonCfImpacteList = async () => {
    const enteteList = ['BON_CF_IMPACTE_ENTETE_UNITE_DE_PRODUCTION', 'BON_CF_IMPACTE_ENTETE_FOURNISSEUR',
      'BON_CF_IMPACTE_ENTETE_DATE_LIVRAISON', 'BON_CF_IMPACTE_ENTETE_NUMERO'].map(this.label);
    const ligneList = this.bonCfImpacteList().map(bonCf =>
      [bonCf.uniteDeProductionLibelle ?? '', this.fournisseurOf(bonCf), this.dateLivraisonOf(bonCf), bonCf.numeroBcf ?? '']);

    const texte = [enteteList, ...ligneList].map(cellList => cellList.join('\t')).join('\n');
    const escapeHtml = (value: string) => value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const html = '<table border="1" style="border-collapse:collapse">'
      + `<tr>${enteteList.map(entete => `<th>${escapeHtml(entete)}</th>`).join('')}</tr>`
      + ligneList.map(cellList => `<tr>${cellList.map(cell => `<td>${escapeHtml(cell)}</td>`).join('')}</tr>`).join('')
      + '</table>';

    let isCopied = true;
    try {
      await navigator.clipboard.write([new ClipboardItem({
        'text/html': new Blob([html], {type: 'text/html'}),
        'text/plain': new Blob([texte], {type: 'text/plain'})
      })]);
    } catch {
      // Hors HTTPS, navigator.clipboard n'existe pas ; execCommand('copy') reste disponible, et l'événement copy
      // permet d'y poser les deux formats
      const onCopy = (event: ClipboardEvent) => {
        event.clipboardData.setData('text/html', html);
        event.clipboardData.setData('text/plain', texte);
        event.preventDefault();
      };
      document.addEventListener('copy', onCopy);
      isCopied = document.execCommand('copy');
      document.removeEventListener('copy', onCopy);
    }
    if (isCopied) this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, this.label('BON_CF_IMPACTE_TABLEAU_COPIE'));
    else this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, this.label('BON_CF_IMPACTE_TABLEAU_COPIE_ECHEC'));
  }

  private doSave = (bonCfIdList: number[]) => {
    this.setSaving(true);
    this.subSavePeriodPrice = this.catalogueAchatSvc.savePricePeriodAndUpdateBonCfList(this.caPP, bonCfIdList).subscribe({
      next: () => {
        this.setSaving(false);
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Sauvegarde de la période de prix réalisée avec succès`);
        this.catalogueAchatSvc.announceSavedPricePeriod();
        this.closeDialog();
      },
      error: () => this.setSaving(false),
      complete: () => this.setSaving(false)
    });
  }

  private setSaving = (isSaving: boolean) => {
    this.isSaving = isSaving;
    this.utilsSvc.announceSubjectBlockui(isSaving);
  }

  isFormValid = (): boolean => {
    return this.articleForm?.valid &&
      this.uniteDeFacturation?.getSelectedItem() &&
      this.uniteDeCommande?.getSelectedItem() &&
      this.uniteStockage?.getSelectedItem();
  }

  onChange = (id: number, propriete: string): void => {
    this.caPP[propriete] = this.unitesMesure.find(unite => unite.id == id);

    this.isSameUCUF = this.caPP.uniteDeCommande.id === this.caPP.uniteDeFacturation.id;
    if (this.isSameUCUF) this.ratioUCUF = 1;
    this.onChangeRatioUC();

    this.isSameUSUT = this.catalogueAchat.uniteTechnique.id === this.caPP.uniteDeStockage.id;
    if (this.isSameUSUT) this.ratioUSUT = 1;
    this.onChangeRatioUS();
  }

  canModify = () => this.utilsSvc.isNullOrEmpty(this.caPP) || this.caPP.id == 0;

  onChangeRatioUC = () => this.caPP.ratioUniteCommandeUniteBase = this.ratioUCUF * this.caPP.ratioUniteFacturationUniteBase;

  onChangeRatioUCUF = () => {
    if (!this.isSameUCUF) this.ratioUCUF = this.caPP.ratioUniteCommandeUniteBase / this.caPP.ratioUniteFacturationUniteBase;
    else this.caPP.ratioUniteFacturationUniteBase = this.caPP.ratioUniteCommandeUniteBase;
  }

  onChangeRatioUS = () => this.caPP.ratioUniteStockageUniteBase = this.ratioUSUT * this.catalogueAchat.ratioUniteTechnique;

  onChangeRatioUSUT = () => {
    if (!this.isSameUSUT) this.ratioUSUT = this.caPP.ratioUniteStockageUniteBase / this.catalogueAchat.ratioUniteTechnique;
  }

  onPriceUpdated = () => {
    this.caPP.groupeAchatCaList[0].prixUF.value = this.caPP.prix;
  };
}
